import {
  FaChartPie,
  FaFileInvoice,
  FaCashRegister,
  FaClipboardList,
  FaUserCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getUserdata } from "../../helper/generalHelper";

const FooterNavStaff = () => {
  const navigate = useNavigate();

  // Get user permissions array
  let userPermissions = getUserdata("permissions") || [];
  if (typeof userPermissions === "string") {
    try { userPermissions = JSON.parse(userPermissions); } catch (e) { userPermissions = []; }
  }
  
  const hasPerm = (ids) => {
    if (!ids || ids.length === 0) return true;
    return Array.isArray(userPermissions) && userPermissions.some(p => ids.includes(Number(p)));
  };

  const navItems = [
    { label: "Dashboard", icon: <FaChartPie />, path: "/restaurant-staff/employee", perms: [1] },
    { label: "Receipt", icon: <FaFileInvoice />, path: "/restaurant-staff/employee/receipt", perms: [153, 155] },
    { label: "Counter", icon: <FaCashRegister />, path: "/restaurant-staff/employee/counter", perms: [123] },
    { label: "Orders", icon: <FaClipboardList />, path: "/restaurant-staff/employee/orders", perms: [26, 27, 28, 29] },
    { label: "Profile", icon: <FaUserCircle />, path: "/restaurant-staff/employee/profile", perms: [128] },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow md:hidden z-50">
      <div className="flex justify-around items-center py-2">
        {navItems.map((item, index) => {
          if (item.perms && item.perms.length > 0 && !hasPerm(item.perms)) return null;
          return (
            <button
              key={index}
              className="flex flex-col items-center text-xs text-gray-700 hover:text-primary"
              onClick={() => navigate(item.path)}
            >
              <div className="text-lg">{item.icon}</div>
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNavStaff;
